import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { listPublicFounders } from "@/lib/founders";

export const fetchPublicFounders = createServerFn({ method: "GET" }).handler(
	async () => {
		const founders = await listPublicFounders({ limit: 200 });
		return { founders };
	},
);

export type PublicFoundersData = Awaited<
	ReturnType<typeof fetchPublicFounders>
>;

export const publicFoundersQueryOptions = queryOptions({
	queryKey: ["public-founders"] as const,
	queryFn: () => fetchPublicFounders(),
	staleTime: 60_000,
});
